<template>
  <div id="MemberUnit">
    <Table :show-header="false" :columns="columns" @on-row-click="onClickMemberUnit" :data="list" no-data-text="暂无筛选结果">
      <template #logo="{ row }">
        <img :src="row.logo" style="width: 80px;height: 80px;margin: 5px;">
      </template>
    </Table>
  </div>
</template>

<script>
import {getMemberUnitList} from "@/request/web/members";

export default {
  name: "MemberUnit",
  data() {
    return {
      columns: [
        {
          title: '协会LOGO',
          width: 120,
          slot: 'logo'
        },
        {
          title: '会员单位名称',
          width: 228,
          key: 'unit_name'
        },
        {
          title: '负责人',
          width: 100,
          key: 'link_man'
        },
        {
          title: '联系地址',
          key: 'address'
        }
      ],
      list: [],
      page: {
        pageIndex: 1,
        pageSize: 4
      },
    }
  },
  created() {
    this.onGetMemberUnitList()
  },
  methods: {
    // 获取会员单位列表
    onGetMemberUnitList() {
      getMemberUnitList({
        ...this.page,
        filter: {}
      }).then(res=> {
        this.list = res.data.data.list
      })
    },
    onClickMemberUnit(unit) {
      this.$router.push(`/member/detail/${unit['unit_id']}`)
    }
  }
}
</script>

<style scoped>
table {
  text-align: left;
  width: 100%;
  border-collapse:collapse;
}

table thead {
  color: #fff;
}

table thead tr {
  color: #fff;
  height: 25px;
  cursor: pointer;
}

table thead tr th {
  height: 25px;
}

table tbody tr {
  cursor: pointer;
}

table tbody tr:hover {
  cursor: pointer;
}

table tbody tr td{
  padding: 5px 0;
}

table body tr td p{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
</style>
